import type { AxiosRequestConfig } from 'axios'

import type { ApiResponse, ApisauceInstance } from '@mangovoice/apisauce'
import type { ApiError } from '@mangovoice/types'

export interface WebhooksNamespace {
  request: {
    get: <T, E = ApiError>(
      url: string,
      params?: Record<string, unknown>,
      config?: AxiosRequestConfig,
    ) => Promise<ApiResponse<T, E>>
    post: <T, E = ApiError>(
      url: string,
      data?: unknown,
      config?: AxiosRequestConfig,
    ) => Promise<ApiResponse<T, E>>
    patch: <T, E = ApiError>(
      url: string,
      data?: unknown,
      config?: AxiosRequestConfig,
    ) => Promise<ApiResponse<T, E>>
    delete: <T, E = ApiError>(
      url: string,
      params?: Record<string, unknown>,
      config?: AxiosRequestConfig,
    ) => Promise<ApiResponse<T, E>>
  }
}

export const createWebhooksNamespace = ({
  withJwt,
  mangoApi,
}: {
  withJwt: (api: ApisauceInstance) => ApisauceInstance
  mangoApi: ApisauceInstance
}): WebhooksNamespace => ({
  request: {
    get: <T, E = ApiError>(
      url: string,
      params?: Record<string, unknown>,
      config?: AxiosRequestConfig,
    ): Promise<ApiResponse<T, E>> => {
      return withJwt(mangoApi).get<T, E>(url, params, config)
    },
    post: <T, E = ApiError>(
      url: string,
      data?: unknown,
      config?: AxiosRequestConfig,
    ): Promise<ApiResponse<T, E>> => {
      return withJwt(mangoApi).post<T, E>(url, data, config)
    },
    patch: <T, E = ApiError>(
      url: string,
      data?: unknown,
      config?: AxiosRequestConfig,
    ): Promise<ApiResponse<T, E>> => {
      return withJwt(mangoApi).patch<T, E>(url, data, config)
    },
    delete: <T, E = ApiError>(
      url: string,
      params?: Record<string, unknown>,
      config?: AxiosRequestConfig,
    ): Promise<ApiResponse<T, E>> => {
      return withJwt(mangoApi).delete<T, E>(url, params, config)
    },
  },
})
